import React from 'react';
// import ComingSoon from '../components/comingSoon';
import ContactData from '../components/contact-data';
import ContactForm from '../components/contact-form'
import usePageMeta from '../hooks/usePageMeta';

export default function Contact() {
    usePageMeta('Contact Spinnennetz | Free CRO Consultation', 'Ready to increase your conversion rate? Contact Spinnennetz for a free consultation on landing pages, A/B testing, and eCommerce store development.', '/contact', {"@context":"https://schema.org","@type":"ContactPage","name":"Contact Spinnennetz","description":"Contact Spinnennetz for a free CRO consultation on landing pages, A/B testing, and eCommerce store development."});
    return (
        <>
            <ContactData />
            <ContactForm />
            {/* <ComingSoon /> */}
        </>
    );
}
